import { EffectsModal } from '../EffectsModal';

export const TotalInjuriesModal = ({ title, event }) => EffectsModal({
  title,
  desc: `Whenever possible, total number of injuries from the ${event} and secondary effects are listed.`,
});
